import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { PlayIcon, PauseIcon, ArrowPathIcon, ClockIcon } from "@heroicons/react/24/outline";

export default function Focus() {
    const WORK_TIME = 25 * 60;
    const BREAK_TIME = 5 * 60;

    const [seconds, setSeconds] = useState(WORK_TIME);
    const [isRunning, setIsRunning] = useState(false);
    const [isBreak, setIsBreak] = useState(false);

    useEffect(() => {
        if (!isRunning) return;

        const timer = setInterval(() => {
            setSeconds(prev => {
                if (prev === 1) {
                    if (isBreak) {
                        setIsBreak(false);
                        return WORK_TIME;
                    } else {
                        setIsBreak(true);
                        return BREAK_TIME;
                    }
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [isRunning, isBreak]);

    const formatTime = (s) => {
        const m = Math.floor(s / 60);
        const sec = s % 60;
        return `${m.toString().padStart(2, "0")}:${sec
            .toString()
            .padStart(2, "0")}`;
    };

    const resetTimer = () => {
        setIsRunning(false);
        setIsBreak(false);
        setSeconds(WORK_TIME);
    };

    return (
        <>
            <Helmet>
                <title>Focus Mode – Pomodoro</title>
            </Helmet>

            <div className="bg-gray-100 flex items-center justify-center px-4 py-4">
                <div className="bg-white rounded-2xl shadow-lg p-8 w-full max-w-md text-center">

                    {/* HEADER */}
                    <div className="flex justify-center items-center gap-2 mb-6">
                        <ClockIcon className="w-7 h-7 text-green-600" />
                        <h1 className="text-2xl font-bold">Pomodoro Focus</h1>
                    </div>

                    {/* MODE */}
                    <p
                        className={`mb-4 text-sm font-medium ${isBreak ? "text-blue-600" : "text-green-600"
                            }`}
                    >
                        {isBreak ? "Thời gian nghỉ" : "Thời gian tập trung"}
                    </p>

                    {/* TIMER */}
                    <div className="text-6xl font-mono font-bold mb-8">
                        {formatTime(seconds)}
                    </div>

                    {/* CONTROLS */}
                    <div className="flex justify-center gap-4">
                        <button
                            onClick={() => setIsRunning(!isRunning)}
                            className="flex items-center gap-2 px-6 py-3 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
                        >
                            {isRunning ? (
                                <>
                                    <PauseIcon className="w-5 h-5" />
                                    Tạm dừng
                                </>
                            ) : (
                                <>
                                    <PlayIcon className="w-5 h-5" />
                                    Bắt đầu
                                </>
                            )}
                        </button>

                        <button
                            onClick={resetTimer}
                            className="flex items-center gap-2 px-6 py-3 border border-gray-300 rounded-xl hover:bg-gray-100 transition"
                        >
                            <ArrowPathIcon className="w-5 h-5" />
                            Reset
                        </button>
                    </div>

                    {/* NOTE */}
                    <p className="mt-6 text-gray-500 text-sm">
                        Chu kỳ: 25 phút tập trung – 5 phút nghỉ
                    </p>
                </div>
            </div>
        </>
    );
}
